const AI_WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbyNnNHQBbhABsBP5LblHoAAN-JzxZorqfFCChXKMsa-Dv93E0KyMJr8PubswpoSVjV_HQ/exec';

export interface AiFiltersRawResponse {
  tipoinmueble: string[];
  ubicacion: string[];
  num_habitaciones: number[];
  num_banos: number[];
  num_parqueaderos: number[];
  estrato: number[];
  con_ascensor: boolean | null;
  precio_min: number | null;
  precio_max: number | null;
  area_min: number | null;
  area_max: number | null;
}

/**
 * Petición al Webhook de IA para interpretar el lenguaje natural.
 * Evita preflight CORS usando una petición simple.
 */
export const fetchAiInterpretation = async (query: string): Promise<AiFiltersRawResponse> => {
  const dataPrompt = `Interpret "${query}". Context: Apartaestudio, Apartamento, Bodega, Casa, Casa campestre, Consultorio, Depósito, Edificio, Finca, Local, Lote, Lote urbano, Oficina, Parqueadero. Output only JSON: {"filters": {"tipoinmueble": [], "ubicacion": [], "num_habitaciones": [], "num_banos": [], "num_parqueaderos": [], "estrato": [], "con_ascensor": bool, "precio_min": num, "precio_max": num, "area_min": num, "area_max": num, "antiguedad_min": num, "antiguedad_max": num}}`;

  const response = await fetch(AI_WEBHOOK_URL, {
    method: 'POST',
    body: JSON.stringify({ data: dataPrompt })
  });

  if (!response.ok) throw new Error(`HTTP ${response.status}`);

  const result = await response.json();

  // Extraemos el contenido del campo 'data' mencionado por el usuario
  // Si es un objeto, lo usamos directamente. Si es un string (JSON), lo parseamos.
  let rawData = result.data;
  
  if (typeof rawData === 'string') {
    try {
      const parsed = JSON.parse(rawData);
      rawData = parsed.filters || parsed;
    } catch (e) {
      console.error("Error parsing AI data string:", e);
    }
  } else if (rawData && rawData.filters) {
    rawData = rawData.filters;
  }
  
  if (!rawData) {
    throw new Error("No se pudo extraer la información del campo 'data'.");
  }

  return rawData;
};